import { ReportScreen } from "../../features/reports/report_screen";
import { ImportScreen } from "../../features/task_import/import_screen";
import { ExamScreen } from "../../features/exam/exam_screen";
import { ExamEditorScreen } from "../../features/exam/exam_editor_screen";
import { TaskScreen, TaskScreenPath } from "../../features/task/task_screen";
import { TaskEditorScreen } from "../../features/task/task_editor_screen";
import { IRouter } from "./routers";
import { StudentScreen } from "../../features/student/student_screen";

export const privateRouters: IRouter[] = [
  { path: "/exam/:id/results", element: <ReportScreen kind="exams" /> },
  { path: "/student/:id/results", element: <ReportScreen kind="students" /> },
  { path: "/student", element: <StudentScreen /> },
  { path: "/exam", element: <ExamScreen /> },
  { path: "/exam/new", element: <ExamEditorScreen /> },
  { path: "/exam/:id/edit", element: <ExamEditorScreen /> },
  { path: TaskScreenPath, element: <TaskScreen /> },
  { path: "/task/import", element: <ImportScreen /> },
  { path: "/task/import/:batch", element: <ImportScreen /> },
  { path: "/task/import/:batch/:entry/edit", element: <TaskEditorScreen /> },
  { path: "/task/new", element: <TaskEditorScreen /> },
  { path: "/task/:id/edit", element: <TaskEditorScreen /> },
];
